import { Component, CUSTOM_ELEMENTS_SCHEMA, input, signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ThemeSwitcherComponent } from '../theme-switcher/theme-switcher.component';

@Component({
    selector: 'app-base-header',
    templateUrl: './base-header.component.html',
    imports: [RouterModule, ThemeSwitcherComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class BaseHeaderComponent {
    public version = input.required<string>();
    public userName = input<string | null>(null);
    public userInfo = input<string | null>(null);
    public userInitials = input<string | null>(null);
    public isAdmin = input<boolean>(false);

    protected mobileMenuOpen = signal(false);

    public toggleMobileMenu(): void {
        this.mobileMenuOpen.update((open) => !open);
    }
}
